import { baseAIURL } from './baseAIURL';

export function importFromDocOrTextURL(quizId: number) {
  const url = baseAIURL();
  url.pathname += `import-questions/${quizId}`;
  return url;
}
